import React, { useState, useContext, useEffect } from "react";
import TopupViewTable from "../Topup View/TopupViewTable";
import { writeFile, utils } from "xlsx";
import { GlobalContext } from "../../Context/GlobalState";
import { Redirect } from "react-router";

const TopupView = () => {
  return (
    <GlobalContext.Consumer>
      {(context) =>
        context.user == null ? (
          <Redirect to="/" />
        ) : (
          <div style={{ margin: "10px" }}>
            <div
              style={{
                display: "flex",
                background: "#30363e",
                color: "#FFF",
                padding: "10px",
                justifyContent: "space-between",
              }}
            >
              <strong>Topup History</strong>
            </div>
            <TopupViewTable />
          </div>
        )
      }
    </GlobalContext.Consumer>
  );
};

export default TopupView;
